export enum PromoEmailTemplateStatus {
  Pending = 1,
  Approved = 2,
}
